<template>
  <div class="bg-blackly flex h-16 fluid-xs leading-tightest text-white">
    <div class="md:container w-full">
      <div class="border-gray-divider-darker flex flex-row h-full border-l border-r relative z-30">
        <div class="md:shadow-none flex items-center mr-auto overflow-x-auto whitespace-nowrap shadow-inner topic-nav">
          <div class="md:block hidden ml-4 mr-6 uppercase font-semibold">{{ $t('topics') }}</div>
          <nuxt-link
            v-for="{ title, path } in topicsLocalized"
            :key="path"
            :to="{ path }"
            :class="{ 'bg-charcoal': !isCurrent(path), 'text-charcoal bg-br-green-light': isCurrent(path) }"
            class="text-br-green-light hover:bg-br-green-light hover:text-charcoal px-4 py-1 ml-4 rounded-full font-medium"
            >{{ title }}</nuxt-link
          >
        </div>
        <Dropdown
          v-if="categories && categories.length"
          :options="categories"
          :heading="categoriesHeading"
          class="border-gray-divider-darker w-48 border-l"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/knowledge/Dropdown';
export default defineNuxtComponent({
  components: {
    Dropdown,
  },
  props: {
    topics: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    topicsLocalized() {
      return this.topics.map((topic) => ({ ...topic, path: this.$localeRootPath(topic.uri) }));
    },
    categoriesHeading() {
      const current = this.$route.params?.category;
      if (!current) return this.$t('categories');
      const currentCategory = this.categories.find((category) => category.route.params.category === current);
      if (!currentCategory) return this.$t('categories');
      return currentCategory.title;
    },
  },
  methods: {
    isCurrent(path) {
      return this.$route.path.startsWith(path);
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.topic-nav {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
}
.topic-nav::-webkit-scrollbar {
  @apply hidden;
}
</style>
